import { render, staticRenderFns } from "./Salary Reports Show.vue?vue&type=template&id=7ee23488"
import script from "./Salary Reports Show.vue?vue&type=script&lang=js"
export * from "./Salary Reports Show.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports